<template>
  <CmTable
    :columns="config.columns"
    :rows="rows"
    :childrenColumns="config.childrenColumns"
    :isLoading="isLoading"
    :isError="isError"
    class="general-statistics-table"
  >
    <router-link
      slot="Name"
      slot-scope="props"
      :to="{
        name: 'statistics-promotion',
        params: { id: props.row.ID }
      }"
    >
      <span class="general-statistics-table__promotion-name">{{ props.row.Name }}</span>
      <div class="general-statistics-table__promotion-details">
        <span class="promotion-details__started-time">
          {{ mt.tsToLocalDateTime(props.row.StartedDate, " в ") }}
        </span>
        <PromotionTypeIcon :type="props.row.Type" />
        <PromoStatus
          class="promotion-details__status"
          :type="props.row.Status"
        />
      </div>
    </router-link>

    <div
      slot="membersCount"
      slot-scope="props"
      class="general-statistics-table__members-count"
    >
      <span>
        <b>{{ fNum.format(props.row.Stats.ContactsCount) }}</b>
        {{ fStr.getRusEnding(props.row.Stats.ContactsCount, ['участник', 'участника', 'участников'])}}
      </span>
      <span
        class="text--light general-statistics-table__segment-toggle"
        @click="props.toggleRow(props.rowIndex)"
      >
        <b>{{ props.row.Stats.SegmentsCount }}</b>&nbsp;
        {{ fStr.getRusEnding(props.row.Stats.SegmentsCount, ['сегмент', 'сегмента', 'сегментов'])}}
        <CmToggleIcon :isUp="props.isOpen" />
      </span>
    </div>

    <b slot="sent" slot-scope="props" class="general-statistics-table__sent-count">
      {{ fNum.format(props.row.sent) }}
    </b>

    <PiePercentagePart
      v-for="(chart, chartKey) in config.charts"
      :key="chartKey + props.row.ID + props.row.Index"
      :id="chartKey + props.row.ID + props.row.Index"
      :slot="chartKey"
      slot-scope="props"
      :data="config.getPiePercantageData(props.row.Stats.MsgStats, chartKey)"
      :color="chart.color"
      :additionalText="type === 'promotions' ? 'доставлено' : ''"
    />

    <!-- children slots -->
    <span
      slot="SegmentName"
      slot-scope="props"
      class="general-statistics-table__segment-name"
    >
      {{ props.row.SegmentName || 'Без названия' }}
    </span>

    <div
      slot="SegmentID"
      slot-scope="props"
      class="general-statistics-table__members-count"
    >
      <span>
        <b>{{ fNum.format(props.row.Stats.ContactsCount) }}</b>
        {{ fStr.getRusEnding(props.row.Stats.ContactsCount, ['участник', 'участника', 'участников'])}}
      </span>
    </div>
  </CmTable>
</template>

<script>
import CmTable from "@/components/library/CmTable.vue";
import PiePercentagePart from "@/components/statistics/general/PiePercentagePart.vue";
import CmToggleIcon from "@/components/library/CmToggleIcon.vue";

import tableConfig from "./tableConfig/index";
import tables_mixin from "@/components/statistics/tables_mixin";
import tableFiltersMixin from "./tableFiltersMixin";

export default {
  name: "StatisticsTable",

  props: {
    availableSteps: {
      type: Array,
      default: () => []
    }
  },

  mixins: [tables_mixin, tableFiltersMixin],

  components: {
    CmTable,
    CmToggleIcon,
    PiePercentagePart
  },

  computed: {
    config() {
      // hide some steps for partners based on the config (statisticsSteps) if they are not used
      if (this.type === "promotions") {
        const { columns, childrenColumns, formStepColumns } = tableConfig[this.type];
        return {
          ...tableConfig[this.type],
          columns: { ...columns, ...formStepColumns(this.availableSteps) },
          childrenColumns: { ...childrenColumns, ...formStepColumns(this.availableSteps) }
        };
      }

      return tableConfig[this.type];
    },

    rows() {
      if (this.info && this.info.Promotions) {
        const arr = [
          ...this.info.Promotions
        ];

        arr.forEach((i, index) => {
          const { SegmentsCount, ContactsCount: membersCount } = i.Stats;
          i.Index = index;
          i.membersCount = membersCount;
          i.segmentsCount = SegmentsCount;
          i.children = this.config.formChildren(i.Segments, i.ID);
          this.config.generateAdditionalFields(i);
        });

        // filter data
        let filteredData = []
        const { name, tagFilter, providerFilter } = this.filters;

        // filter by Promotion Name
        filteredData = arr.filter(i => i.Name.toLowerCase().includes(name.toLowerCase()));
        filteredData = this.filterByTags(filteredData, tagFilter);
        filteredData = this.filterByProvider(filteredData, providerFilter);

        return filteredData.sort((a, b) => b.StartedDate - a.StartedDate);
      }
      return null;
    }
  }
}
</script>

<style lang="scss">
.general-statistics-table {
  padding-top: 5px;
  margin-bottom: 25px;

  a, a:focus {
    color: unset;
  }

  thead {
    th:first-of-type {
      position: relative;
      padding-bottom: 20px;
      min-width: 200px !important;
      &:after {
        content: "Дата и время запуска";
        position: absolute;
        bottom: 2px;
        left: 10px;
        color: $color_gray_lighter;
        font-weight: normal;
      }
    }
  }

  &__promotion-details {
    display: flex;
    align-items: center;
    padding: 5px 0 15px;
    min-width: 128px;
  }

  .promotion-details {
    &__started-time {
      color: $color_gray_lighter;
      margin-right: auto;
      margin-top: 10px;
    }
    &__status {
      border-left: 1px solid $color_gray_lighter;
      padding-left: 17px;
      margin-left: 10px;
    }
  }

  &__members-count {
    .text--light {
      color: $color_gray_lighter;
      margin-top: 15px;
    }
  }

  &__sent-count {
    display: inline-block;
    padding: 0 0 36px;
  }

  &__segment-toggle {
    display: flex;
    align-items: center;
    white-space: nowrap;
    cursor: pointer;
    .cm-toggle-icon {
      border-top-color: $color_green-new;
    }
  }
}
</style>
